import type {Roles} from './types';

export const boUserServiceTypes = {
    service: Symbol('BoUserService'),
    epicsBuilder: Symbol('BoUserEpicsBuilder'),
} as const;

export const allRoles: Roles[] = ['Admins', 'Agent Managers', 'Agents', 'Country-level Partners'];

export const BoUserTypeName = 'BoUser';
export const BoUserViewModelTypeName = 'BoUserViewModel';
export const BoUserViewModelKeysTypeName = 'BoUserViewModelKeys';
export const BoUserQueryFieldsTypeName = 'BoUserQueryFields';
export const BoUserEditViewModelTypeName = 'BoUserEditViewModel';
export const BoUserSaveBasePayloadTypeName = 'BoUserSaveBasePayload';
export const BoUserDataGridColumnsTypeName = 'BoUserDataGridColumns';
